<template>
    <div>
        <v-container style="max-width: 1500px !important">
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 2rem !important;">
                <v-system-bar class="py-5 px-3 system-bar-title" dark>
                    Carga KtV
                    <v-dialog v-model="dialogImportar" v-if="dialogImportar" max-width="600px" persistent>
                    <Importar @closeDialog="closeDialog" />
                    </v-dialog>
                    <div>
                        <!-- <v-tooltip bottom color="success">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="green" v-bind="attrs" v-on="on" dark @click="exportExcel"
                                    style="margin: 1rem 0;height: 1.9rem;">
                                    <v-icon color="white"
                                        style="font-size: 1.5rem;color: white !important;">mdi mdi-download-box</v-icon>
                                </v-btn>
                            </template>
                            <span>Descargar</span>
                        </v-tooltip> -->
                    </div>
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 2rem !important;">
                <v-row style="padding: 1rem;">
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchPaciente" label="Usuario"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3"
                        style="padding: 0 1.5rem 0 0 !important;display:flex;justify-content: end;">
                        <v-tooltip bottom color="info">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" dark class="mb-2"
                                    style="margin: .9rem 0 .7rem .9rem;background: #1780cd;" @click="openDialog"> IMPORTAR
                                    <v-icon style="font-size: 1.8rem;">
                                        mdi mdi-arrow-up-box
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Importar</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-card>
            <v-card style="padding: 1rem;">
                <!-- Cabecera personalizada fuera del v-data-table -->
                <v-data-table :headers="headers" :items="filteredData" dense>
                </v-data-table>
            </v-card>
            <v-dialog v-model="dialogLoader" persistent width="300"
                style="padding: 1rem;overflow: hidden !important;background: white !important;">
                <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
            </v-dialog>
        </v-container>
    </div>
</template>
<style scoped>
@media print {
    .no-print {
        display: none;
    }
}
.system-bar-title {
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 1.2rem 1.4rem !important;
}

.globulos-blancos-column {
    background-color: #f0f8ff !important;
    /* Cambia el color de fondo */
    color: #333 !important;
    /* Cambia el color del texto */
    font-weight: bold !important;

}

.toggle-text {
    font-size: 1rem;
}

.head-text {
    font-size: .9rem;
    font-weight: 600;
    color: rgb(121, 121, 121);
    border-bottom: 1px solid #c1c1c1;
    border-top: 1px transparent;
    padding: 0 1.5rem;

}

.system-bar-title {
    padding: 1.2rem 1.4rem !important;
}

.layout-loading {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 202;
    background: #e3e3e3b1;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

::v-deep tr th {
    text-wrap: nowrap !important;
}

::v-deep .v-card {
    box-shadow: 0px 0px 11px 6px rgb(15 61 99 / 27%) !important;
}

::v-deep tr td {
    text-wrap: nowrap !important;
}

::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
}

.custom-btn {
    width: 32px !important;
    height: 32px !important;
}

.custom-icon {
    font-size: 20px !important;
}

.bg-primary-table {
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

td {
    white-space: nowrap;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
/* import Swal from "sweetalert2"; */
import Importar from "./importar.vue";

export default {
    data() {
        return {
            dialogLoader:false,
            dialogImportar:false,
            dialogHistograma: false,
            dataPaciente:[],
            headers:[
            {
                text: "Nombre archivo",
                value: "nombre_archivo",
                },
                {
                text: "Tipo",
                value: "tipo_archivo",
                },
                {
                text: "Usuario",
                value: "usuario",
                },
                {
                text: "Fecha",
                value: "fecha_carga",
                },
                {
                text: "Estado",
                value: "estado",
                }
            ],
            searchPaciente:null
        };
    },
    methods: {
        closeDialog(){
            this.dialogImportar=false;
            this.listarRegistro();
        },
        openDialog(){
            this.dialogImportar=true;
        },
        listarRegistro(){
            this.dialogLoader=true;
            axios
          .post(RUTA_API + "/api/token/", {
            username: USUARIO,
            password: PASSWORD,
          }).then((response) => {
            this.auth = "Bearer " + response.data.access;
            axios.get
              (
                RUTA_API + "/registroCarga/",
                {
                  headers:
                    { Authorization: this.auth }
                }
              ).then((res) => {
                this.dialogLoader=false;
                this.dataPaciente=res.data;
              }).catch((error) => {
                this.dialogLoader=false;
              });
          })
          .catch((res) => {
            console.log("Error:", res);
          });
        }
    },
    mounted() { },
    computed: {
        filteredData() {
            if (!this.searchPaciente) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchPaciente) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.usuario;
                    return nombreCompleto.toLowerCase().includes(this.searchPaciente.toLowerCase());
                });
            }

            return filtered;
        },
    },
    created() {
        this.listarRegistro();
    },
    components: {
        Importar
    },
};
</script>